import { ChangeEvent, useState } from 'react';
import { EnterTwoFactorCodeInputProps } from './EnterTwoFactorInput.interfaces';
import { FlexContainer, Input } from '@netfront/ui-library';

export default function EnterTwoFactorCodeInput({
  onEnterTwoFactorCode,
  isSubmitting,
  id,
  label,
  ...rest
}: EnterTwoFactorCodeInputProps) {
  const [code, setCode] = useState<string>('');

  function onUpdateCode(newValue: string) {
    setCode(newValue);
    if (newValue.length === 6) {
      onEnterTwoFactorCode(newValue);
    }
  }

  return (
    <FlexContainer flexDirection="column" alignItems="center" isFullWidth gap="small">
      <p className="c-confirm-qr-code__label">
        {label ?? (
          <>
            Enter the <strong>6-digit</strong> code you see in the app
          </>
        )}
      </p>
      <Input
        id={id}
        isLabelHidden={true}
        labelText="Enter the 6-digit code you see in the app"
        maxLength={6}
        name="one-time-passcode"
        type="text"
        isDisabled={isSubmitting}
        value={code}
        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => onUpdateCode(value)}
        {...rest}
      />
    </FlexContainer>
  );
}
